












import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Checkbox extends Vue {
  @Prop({ required: true })
  private readonly value!: boolean;

  @Prop({ required: true })
  private readonly label!: string;

  private isChecked = false;

  mounted () {
    this.isChecked = this.value
  }

  @Watch('value')
  handleValChanged () {
    this.isChecked = this.value
  }

  handleUpdated () {
    const cb = this.$refs.cb as HTMLInputElement

    this.isChecked = cb.checked

    this.$emit('input', cb.checked)
  }
}
